export default __webpack_public_path__ + "static/media/user.65946577.svg";